import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={colorValue}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5739 2.67465C12.2999 2.56123 11.9985 2.53153 11.7077 2.5893C11.4169 2.64707 11.1494 2.79005 10.9397 2.99956L6.43934 7.49989H4.51C3.36841 7.49989 2.19131 8.16396 1.84889 9.40487C1.62123 10.232 1.50004 11.1018 1.5 11.9995C1.49917 12.8763 1.6165 13.7492 1.84881 14.5946L1.84909 14.5956C2.19148 15.8349 3.36794 16.4999 4.51 16.4999H6.43934L10.94 21.0005C11.1498 21.2101 11.4169 21.3527 11.7077 21.4105C11.9985 21.4682 12.2999 21.4385 12.5739 21.3251C12.8478 21.2117 13.0819 21.0196 13.2468 20.7732C13.4116 20.5268 13.4997 20.2364 13.5 19.9399V4.05923C13.4997 3.76275 13.4116 3.47299 13.2468 3.22656C13.0819 2.98013 12.8478 2.78808 12.5739 2.67465ZM12 4.06055L7.28033 8.78022C7.13968 8.92087 6.94892 8.99989 6.75 8.99989H4.51C3.89164 8.99989 3.42061 9.34826 3.295 9.80332C3.10278 10.5019 3 11.2379 3 11.9999C2.99927 12.7418 3.09851 13.4812 3.29504 14.1966C3.42083 14.6511 3.89226 14.9999 4.51 14.9999H6.75C6.94892 14.9999 7.13968 15.0789 7.28033 15.2196L12 19.9392V4.06055Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7803 9.21955C17.4874 8.92665 17.0126 8.92665 16.7197 9.21955C16.4268 9.51244 16.4268 9.98731 16.7197 10.2802L18.4393 11.9999L16.7197 13.7195C16.4268 14.0124 16.4268 14.4873 16.7197 14.7802C17.0126 15.0731 17.4874 15.0731 17.7803 14.7802L19.5 13.0605L21.2197 14.7802C21.5126 15.0731 21.9874 15.0731 22.2803 14.7802C22.5732 14.4873 22.5732 14.0124 22.2803 13.7195L20.5607 11.9999L22.2803 10.2802C22.5732 9.98731 22.5732 9.51244 22.2803 9.21955C21.9874 8.92665 21.5126 8.92665 21.2197 9.21955L19.5 10.9392L17.7803 9.21955Z"
        fill={colorValue}
      />
    </svg>
  );
};
